import type {DatePickerProps} from '@wix/wix-ui-tpa/date-picker'
import loadable from '@wix/yoshi-flow-editor/loadable'

const DatePicker = loadable<DatePickerProps>(
  async () => import(/* webpackPreload: true, webpackChunkName: "date-picker" */ '@wix/wix-ui-tpa/date-picker'),
  {
    resolveComponent: components => components.DatePicker,
  },
)

export default DatePicker
